import { render, staticRenderFns } from "./popupWindow.vue?vue&type=template&id=22ea0a8b&scoped=true&"
import script from "./popupWindow.vue?vue&type=script&lang=js&"
export * from "./popupWindow.vue?vue&type=script&lang=js&"
import style0 from "./popupWindow.vue?vue&type=style&index=0&id=22ea0a8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea0a8b",
  null
  
)

export default component.exports